import React from "react";
import "../App.css";

export default function TermsOfServicePage() {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "1.8rem", marginBottom: "5px", color: "#1f2937" }}>
        Terms of Service
      </h1>
      <p style={{ fontSize: "0.9rem", color: "#6b7280", marginBottom: "20px" }}>
        Last updated: July 28, 2025
      </p>

      <p style={paragraphStyle}>
        Welcome to Robito.ai. These Terms of Service (“Terms”) govern your use of our
        automation platform and related services (“Services”). By using our platform, you
        agree to these Terms in full.
      </p>

      <h2 style={sectionTitleStyle}>1. Account Responsibilities</h2>
      <p style={paragraphStyle}>
        You are responsible for maintaining the confidentiality of your account credentials
        on Robito.ai. Any activity conducted under your account is your responsibility.
        You must ensure that the information you provide is accurate and kept up to date.
      </p>

      <h2 style={sectionTitleStyle}>2. Service Usage</h2>
      <p style={paragraphStyle}>
        Robito.ai provides automation tools to manage and reply to Google Play reviews.
        To enable automation, you will need to invite our service account 
        (<strong>robito-service@review-automation-467010.iam.gserviceaccount.com</strong>)
        to your Google Play Developer Console and grant the required permissions:
      </p>
      <ul style={listStyle}>
        <li>View app information and download bulk reports (read-only).</li>
        <li>Reply to reviews.</li>
      </ul>
      <p style={paragraphStyle}>
        You agree not to use the Services for any unlawful purpose or in violation of
        Google Play Developer policies. Robito.ai is not liable for any actions taken by
        Google against your developer account resulting from your misuse of the Services.
      </p>

      <h2 style={sectionTitleStyle}>3. Credits, Payments & Refunds</h2>
      <p style={paragraphStyle}>
        Our platform operates on a credit-based system. Each automated reply or simulation
        consumes credits. Credits are non-refundable and do not expire. Please review
        pricing and available packages before making a purchase.
      </p>

      <h2 style={sectionTitleStyle}>4. Data Security and Privacy</h2>
      <p style={paragraphStyle}>
        We do not collect or store your Google Play API access tokens. All Google Play
        interactions are executed through our dedicated service account that you authorize.
        Your app data and reviews are processed solely for the purpose of providing
        automation services. Please review our Privacy Policy for more details.
      </p>

      <h2 style={sectionTitleStyle}>5. Service Limitations & Quotas</h2>
      <p style={paragraphStyle}>
        Our Services adhere to Google Play Developer API quotas, including 200 GET
        requests per hour and 2000 POST replies per day per app. Robito.ai is not
        responsible if quota limitations prevent replies or delays in automation.
      </p>

      <h2 style={sectionTitleStyle}>6. Disclaimer of Liability</h2>
      <p style={paragraphStyle}>
        Robito.ai provides Services “as is” without warranties of any kind. We are not
        responsible for any damages, penalties, or losses resulting from AI-generated
        responses, misuse of the platform, or violation of Google policies. You are
        responsible for reviewing and ensuring the compliance of replies generated by the
        platform.
      </p>

      <h2 style={sectionTitleStyle}>7. Termination</h2>
      <p style={paragraphStyle}>
        We reserve the right to suspend or terminate your account at any time, without
        notice, if you:
      </p>
      <ul style={listStyle}>
        <li>Violate these Terms or applicable laws.</li>
        <li>Engage in fraudulent or abusive activities.</li>
        <li>Attempt to bypass system quotas or security measures.</li>
      </ul>

      <h2 style={sectionTitleStyle}>8. Changes to Terms</h2>
      <p style={paragraphStyle}>
        We may update these Terms periodically. Significant updates will be communicated
        via email or in-app notifications. Continued use of our Services after such updates
        indicates your acceptance of the revised Terms.
      </p>

      <h2 style={sectionTitleStyle}>9. Contact Us</h2>
      <p style={paragraphStyle}>
        For any questions or concerns about these Terms, please contact us at
        <strong> developer@robito.ai</strong>.
      </p>
    </div>
  );
}

const paragraphStyle = {
  fontSize: "1rem",
  color: "#4b5563",
  marginBottom: "20px",
  lineHeight: "1.6",
};

const sectionTitleStyle = {
  fontSize: "1.2rem",
  fontWeight: "600",
  marginBottom: "10px",
  color: "#1f2937",
};

const listStyle = {
  marginLeft: "20px",
  color: "#4b5563",
  fontSize: "1rem",
  lineHeight: "1.6",
  marginBottom: "20px"
};
